import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetExtractTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setExtractTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
